document.addEventListener('DOMContentLoaded', function () {
  function initializeSwiper() {
    const ugcCarousel = document.querySelector('.swiper-container.ugc-carousel');

    if (!ugcCarousel) return;

    const currentEl = document.querySelector('.ugc-carousel__current');
    const progressFill = document.querySelector('.ugc-carousel__progress-fill');
    const progressBar = document.querySelector('.ugc-carousel__progress-bar');

    const swiper = new Swiper(ugcCarousel, {
      slidesPerView: 1,
      loop: false,
      lazy: { loadPrevNext: true, loadPrevNextAmount: 1 },
      
      // Enable mousewheel for trackpad swipe
      mousewheel: {
        forceToAxis: true,
        sensitivity: 1,
        releaseOnEdges: true,
      },
      
      // Enable free mode for smoother dragging
      freeMode: {
        enabled: true,
        sticky: true, // Snap to slides after drag
      },
      
      // Enable grab cursor
      grabCursor: true,
      
      pagination: { el: '.slider__pagination', clickable: true },
      navigation: { nextEl: '.swiper-button-next', prevEl: '.swiper-button-prev' },
      breakpoints: { 
        640: { slidesPerView: 2 }, 
        992: { slidesPerView: 3 }, 
        1200: { slidesPerView: 4 } 
      },
      on: {
        init: function() {
          updatePagination(this);
          initProgressBarDrag(this);
        },
        slideChange: function() {
          updatePagination(this);
        },
        progress: function() {
          updatePagination(this);
        }
      }
    });

    function updatePagination(swiperInstance) {
      const currentIndex = swiperInstance.realIndex + 1;
      const slidesPerView = swiperInstance.params.slidesPerView;
      if (!totalUGCSlides) return;
      const progress = (currentIndex / (totalUGCSlides - slidesPerView + 1)) * 100;
      
      if (currentEl) currentEl.textContent = currentIndex;
      if (progressFill) progressFill.style.width = Math.min(progress, 100) + '%';
    }

    // Make progress bar draggable
    function initProgressBarDrag(swiperInstance) {
      if (!progressBar) return;

      let isDragging = false;

      const getProgressFromEvent = (e) => {
        const rect = progressBar.getBoundingClientRect();
        const clientX = e.type.includes('touch') ? e.touches[0].clientX : e.clientX;
        let progress = (clientX - rect.left) / rect.width;
        return Math.max(0, Math.min(1, progress));
      };

      const updateSlideFromProgress = (progress) => {
        const slidesPerView = swiperInstance.params.slidesPerView;
        const maxIndex = totalUGCSlides - slidesPerView;
        const targetIndex = Math.round(progress * maxIndex);
        swiperInstance.slideTo(targetIndex);
      };

      // Mouse events
      progressBar.addEventListener('mousedown', (e) => {
        isDragging = true;
        progressBar.style.cursor = 'grabbing';
        const progress = getProgressFromEvent(e);
        updateSlideFromProgress(progress);
      });

      document.addEventListener('mousemove', (e) => {
        if (!isDragging) return;
        const progress = getProgressFromEvent(e);
        if (progressFill) progressFill.style.width = (progress * 100) + '%';
        updateSlideFromProgress(progress);
      });

      document.addEventListener('mouseup', () => {
        if (isDragging) {
          isDragging = false;
          progressBar.style.cursor = 'pointer';
        }
      });

      // Touch events
      progressBar.addEventListener('touchstart', (e) => {
        isDragging = true;
        const progress = getProgressFromEvent(e);
        updateSlideFromProgress(progress);
      });

      document.addEventListener('touchmove', (e) => {
        if (!isDragging) return;
        const progress = getProgressFromEvent(e);
        if (progressFill) progressFill.style.width = (progress * 100) + '%';
        updateSlideFromProgress(progress);
      });

      document.addEventListener('touchend', () => {
        isDragging = false;
      });

      // Click to jump
      progressBar.addEventListener('click', (e) => {
        const progress = getProgressFromEvent(e);
        updateSlideFromProgress(progress);
      });

      // Styling
      progressBar.style.cursor = 'pointer';
    }

    // Add slideChange event after Swiper initialization
    swiper.on('slideChange', () => {
      setTimeout(() => {
        const activeSlides = swiper.slides.filter(slide => 
          slide.classList.contains('swiper-slide-active') || 
          slide.classList.contains('swiper-slide-next')
        );
        document.querySelectorAll('.video-section__media video').forEach(video => {
          if (!video.paused) {
            const parentSlide = video.closest('.swiper-slide');
            if (!activeSlides.includes(parentSlide)) {
              video.pause();
              const button = video.closest('.video-section__media').querySelector('.video_play_pause');
              if (button) {
                button.classList.add('video_play_pause--paused');
                button.classList.remove('video_playing');
                button.setAttribute('aria-label', 'Play video');
              }
            }
          }
        });
      }, 300);
    });

    // Play next video when current video ends
    function playNextVideo(currentVideo) {
      const allVideos = Array.from(document.querySelectorAll('.video-section__media video'));
      const currentIndex = allVideos.indexOf(currentVideo);
      const totalSlides = swiper.slides.length;
      const currentSlideIndex = swiper.realIndex;

      const slidesPerView = swiper.params.slidesPerView;
      const lastVideoIndexInView = Math.min(currentSlideIndex + slidesPerView - 1, totalSlides - 1);
      const isLastVideo = currentIndex === lastVideoIndexInView;

      const nextIndex = (currentIndex + 1) % allVideos.length;
      const nextVideo = allVideos[nextIndex];
      const nextSlide = nextVideo.closest('.video-item');
      const nextPlayPauseButton = nextSlide.querySelector('.video_play_pause');
      const nextMuteUnmuteButton = nextSlide.querySelector('.video_mute_unmute');

      if (isLastVideo) {
        swiper.slideNext();
      }

      if (nextVideo && nextPlayPauseButton) {
        pauseAllOtherVideos(nextVideo);

        setTimeout(() => {
          nextPlayPauseButton.click();
          if (!nextMuteUnmuteButton.classList.contains('video_unmuted')) {
            nextMuteUnmuteButton.click();
          }
        }, 300);
      }
    }

    document.querySelectorAll('.video-section__media video').forEach((video) => {
      video.addEventListener('ended', () => {
        video.closest('.video-item').querySelector('.video_play_pause').classList.remove('video_playing');
        playNextVideo(video);
      });
    });

    return swiper;
  }

  function pauseAllOtherVideos(currentVideo) {
    document.querySelectorAll('.video-section__media video').forEach((video) => {
      if (video !== currentVideo && !video.paused) {
        video.pause();
        const button = video.closest('.video-section__media').querySelector('.video_play_pause');
        if (button) {
          button.classList.add('video_play_pause--paused');
          button.classList.remove('video_playing');
          button.setAttribute('aria-label', 'Play video');
        }
      }
    });
  }

  document.querySelectorAll('.video-section__media').forEach((deferredMedia) => {
    const playPauseButton = deferredMedia.querySelector('.video_play_pause');
    const muteUnmuteButton = deferredMedia.querySelector('.video_mute_unmute');

    function getVideoElement() {
      return deferredMedia.querySelector('video');
    }

    function togglePlayPause(video, button) {
      if (video.paused) {
        pauseAllOtherVideos(video);
        video.play().then(() => {
          button.classList.remove('video_play_pause--paused');
          button.classList.add('video_playing');
          button.setAttribute('aria-label', 'Pause video');
        }).catch((err) => console.warn('Video play error:', err));
      } else {
        video.pause();
        button.classList.add('video_play_pause--paused');
        button.classList.remove('video_playing');
        button.setAttribute('aria-label', 'Play video');
      }
    }

    if (playPauseButton) {
      playPauseButton.addEventListener('click', () => {
        const video = getVideoElement();
        if (video) togglePlayPause(video, playPauseButton);
      });
      playPauseButton.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          const video = getVideoElement();
          if (video) togglePlayPause(video, playPauseButton);
        }
      });
    }

    function toggleMuteUnmute(video, button) {
      video.muted = !video.muted;
      button.classList.toggle('video_muted', video.muted);
      button.classList.toggle('video_unmuted', !video.muted);
      button.setAttribute('aria-label', video.muted ? 'Unmute video' : 'Mute video');
    }

    if (muteUnmuteButton) {
      muteUnmuteButton.addEventListener('click', () => {
        const video = getVideoElement();
        if (video) toggleMuteUnmute(video, muteUnmuteButton);
      });
      muteUnmuteButton.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          const video = getVideoElement();
          if (video) toggleMuteUnmute(video, muteUnmuteButton);
        }
      });
    }
  });

  initializeSwiper();
});